module.exports = __webpack_public_path__ + "img/80.b38d92ac.jpg";